import { ITreeNode } from '@blueprintjs/core'
import get from 'lodash/fp/get'
import { LocationNodeType } from '../../components/LocationGroupTrees/components'
import { LocationTreeNodeT } from './forEachNode'

const makeSelectEachNodeByFloorWorkdayTime =
  (selectedFloorIds: string[]) =>
  (parent: ITreeNode): void => {
    const nodeType = (parent as LocationTreeNodeT).nodeData?.nodeType
    const hasSelectedFloorId = (floorTreeNode: ITreeNode) =>
      selectedFloorIds.includes(getFloorId(floorTreeNode))

    bookingWorkdayPredicatesMap[nodeType as LocationNodeType]?.(parent, hasSelectedFloorId)
  }

export default makeSelectEachNodeByFloorWorkdayTime

type HasBookingTime = (
  treeNode: ITreeNode,
  hasSelectedFloorId: (treeNode: ITreeNode) => boolean
) => void

const hasLocationFloorWithBookingTime: HasBookingTime = (treeNode, hasSelectedFloorId) => {
  treeNode.isSelected = treeNode.childNodes?.some((city) =>
    city.childNodes?.some((building) => building.childNodes?.some(hasSelectedFloorId))
  )
}

const hasCityFloorWithBookingTime: HasBookingTime = (treeNode, hasSelectedFloorId) => {
  treeNode.isSelected = treeNode.childNodes?.some((building) =>
    building.childNodes?.some(hasSelectedFloorId)
  )
}

const hasBuildingFloorWithBookingTime: HasBookingTime = (treeNode, hasSelectedFloorId) => {
  treeNode.isSelected = treeNode.childNodes?.some(hasSelectedFloorId)
}

const hasFloorBookingTime: HasBookingTime = (treeNode, hasSelectedFloorId) => {
  treeNode.isSelected = hasSelectedFloorId(treeNode)
}

const bookingWorkdayPredicatesMap: { [key in LocationNodeType]: HasBookingTime } = {
  [LocationNodeType.Location]: hasLocationFloorWithBookingTime,
  [LocationNodeType.City]: hasCityFloorWithBookingTime,
  [LocationNodeType.Building]: hasBuildingFloorWithBookingTime,
  [LocationNodeType.Floor]: hasFloorBookingTime,
}

const getFloorId = get('nodeData.floor.id')
